const v = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M5 3.75A2.75 2.75 0 0 0 2.25 6.5v11A2.75 2.75 0 0 0 5 20.25h13a3.75 3.75 0 0 0 3.75-3.75v-10A2.75 2.75 0 0 0 19 3.75zM3.75 6.5c0-.69.56-1.25 1.25-1.25h1.75v2.5h-3zm0 2.75v8.25c0 .69.56 1.25 1.25 1.25h1.75v-9.5zm4.5 9.5H18a2.25 2.25 0 0 0 2.25-2.25V9.25h-12zm12-11V6.5c0-.69-.56-1.25-1.25-1.25H8.25v2.5z" clip-rule="evenodd"/></svg>';
export {
  v as w
};
